import styled from 'styled-components';
import { black } from 'styles/colors';
import { ApButtonMain } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 32px 24px 32px;
	max-width: 420px;
`;

export const Title = styled.div`
	color: ${black};
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
	margin-bottom: 16px;
`;

export const Text = styled.div`
	color: ${black};
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 21px;
	margin-bottom: 16px;
`;

export const Action = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const StyledButton = styled(ApButtonMain)`
	transition: none !important;
`;
